export enum VerticalNavigationItemStatus {
  Empty = 0, // no icon
  Ok = 1, // success icon
  Error = 2 // error icon
}
